import React from "react";

const Error404 = () => {
  return (
    <div>
      <h1>ERROR 404 UPS !!!</h1>
      <h2>Why are you here? Come on, don't waste your time...</h2>
    </div>
  );
};

export default Error404;
